import { render, staticRenderFns } from "./ent-register-modal.vue?vue&type=template&id=55c5488e&"
import script from "./ent-register-modal.vue?vue&type=script&lang=js&"
export * from "./ent-register-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ent-register-modal.vue"
export default component.exports